module.exports = __webpack_public_path__ + "static/media/bindEnterprise2.1afcda0a.png";